import React from 'react';
import { Spin } from 'antd';

const RevenueSummaryPaneFragment = ({ executing, value, description }) => (
  <div
    style={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'flex-start',
      justifyContent: 'center',
      paddingRight: 15,
    }}
  >
    {executing ? <Spin /> : <h3 style={{ margin: 0 }}>{value}</h3>}
    <h5 style={{ margin: 0, color: 'rgb(128, 128, 128)' }}>{description}</h5>
  </div>
);

export default RevenueSummaryPaneFragment;
